import config from "../config";

const { clientId, scope, redirectUri, silentRedirectUri } = config.oidcProps;

export const oidcSettings = {
  authority:
    "https://login.microsoftonline.com/132b9871-e025-4ead-a34d-7bd5e7a383b4/v2.0",
  clientId,
  redirectUri,
  responseType: "code",
  scope,
  automaticSilentRenew: true,
  silentRedirectUri,
  automaticSilentSignin: false,
};
